import FunnelContainer from '@components/funnel/FunnelContainer'
import { DefaultPageTemplate } from '@components/shared/templates/DefaultPageTemplate'
import { GetServerSideProps } from 'next'
import MarketplaceHeader from '../../../components/marketplace/MarketplaceHeader'
import { SupportedNetworks } from '../../../config'
import { ProductType } from '../../../types/UtilTypes'

interface MarketplaceCreatePageProps {
  chainId: number
}

export default function MarketplaceCreatePage({ chainId }: MarketplaceCreatePageProps) {
  return (
    <DefaultPageTemplate header={<MarketplaceHeader chainId={chainId} />}>
      <FunnelContainer type={ProductType.marketplace} chainId={chainId} />
    </DefaultPageTemplate>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const chainId = context.params?.chainId || SupportedNetworks.ethereum
  return {
    props: {
      chainId: Number(chainId)
    }
  }
}
